export const navItems = [
  {
    title: "Home",
    providedLink: "/",
  },
  {
    title: "Trending",
    providedLink: "/trending",
  },
  {
    title: "Discover",
    providedLink: "/discover",
  },
  {
    title: "People",
    providedLink: "/people",
  },
  {
    title: "Genres",
    providedLink: "/genres",
  },
];
